module.exports = __webpack_public_path__ + "img/car_barkauf.80ad3907.png";